import React from 'react';
import OptimizePlanTableHeader, { TableHeader } from './OptimizePlanTableHeader';
import OptimizeTableContent, { InputTypes } from './OptimizeTableContent';
import { Level, OptimisationPlanData } from '../OptimizePlan';

interface IProps {
    tableData: OptimisationPlanData[];
    setTableData: React.Dispatch<React.SetStateAction<any>>;
    headerColumns: TableHeader[];
    level: Level;
}

const OptimizePlanTable: React.FC<IProps> = ({ tableData, setTableData, headerColumns, level }) => {
    const tableColumns = [
        { key: 'label', type: InputTypes.Text, isEditable: false },
        { key: 'originalValue', type: InputTypes.Text, isEditable: false, className: 'text-center' },
        {
            key: '',
            rangeInputKeys: ['min_value', 'max_value'],
            type: InputTypes.Range,
            isEditable: true,
            className: 'text-center',
        },
    ];
    return (
        <div className="border border-[rgba(240,240,240,1)] rounded h-full flex flex-col min-h-0">
            <div className="sticky top-0 bg-white z-10">
                <OptimizePlanTableHeader headerColumns={headerColumns} level={level} />
            </div>

            <div className="overflow-y-auto flex-1 min-h-0">
                {tableData.map((item, index) => (
                    <OptimizeTableContent
                        key={item.name}
                        rowData={item}
                        setTableData={setTableData}
                        index={index}
                        level={level}
                        tableColumns={tableColumns}
                    />
                ))}
            </div>
        </div>
    );
};

export default React.memo(OptimizePlanTable);
